import { pdf } from '@react-pdf/renderer';
import axios from 'axios';

export const downloadFile = async (url: string, name: string) => {
  try {
    const response = await axios.get<Blob>(url, { responseType: 'blob' });

    const blobUrl = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = name;
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Error downloading file:', error);

    throw error;
  }
};

async function downloadReactPdfDocument(doc: React.JSX.Element, options: { title: string }) {
  // Generate PDF blob
  const blob = await pdf(doc).toBlob();

  // Create download link
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = options.title;

  // Trigger download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up
  URL.revokeObjectURL(url);
}

export const downloadFileUtils = {
  downloadReactPdfDocument,
};
